<template>
    <div>
      <input-file v-model="imgs" wh multiple></input-file>
      <input-file v-model="imgs1" multiple></input-file>
    </div>
</template>
<script>
import inputFile from "@/components/common/inputFile/index";
export default {
  components: {
    inputFile
  },
  data() {
    return {
      imgs: [],
      imgs1: []
    };
  }
};
</script>
